var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.164 2.07c.584-1.862 3.22-1.862 3.804 0l.691 2.207a1.993 1.993 0 0 0 1.902 1.397h2.386c1.914 0 2.728 2.434 1.2 3.585l-2.054 1.547a1.993 1.993 0 0 0-.703 2.188l.755 2.41c.58 1.849-1.553 3.353-3.101 2.187l-1.779-1.34a1.993 1.993 0 0 0-2.399 0l-1.778 1.34c-1.548 1.166-3.68-.338-3.101-2.188l.754-2.409a1.993 1.993 0 0 0-.702-2.188L.985 9.26C-.543 8.108.27 5.674 2.185 5.674H4.57c.871 0 1.641-.566 1.902-1.397l.69-2.206Z"
  })));
};
export default SvgStar;